import { useState, useEffect, useCallback, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';

const STORAGE_KEY = 'nm_last_seen_ts';
const STORAGE_COUNT_KEY = 'nm_last_seen_count';
const POLL_INTERVAL_MS = 60_000; // 60 segundos

export function useNMNotifications(token) {
  const [unread, setUnread] = useState(0);
  const [latestNM, setLatestNM] = useState(null);
  const timerRef = useRef(null);
  const qc = useQueryClient();

  const API_URL = process.env.REACT_APP_BACKEND_URL;

  const fetchCount = useCallback(async () => {
    if (!token || !API_URL) return;
    try {
      const lastSeen = localStorage.getItem(STORAGE_KEY) || '0';
      const res = await fetch(
        `${API_URL}/api/near-misses/new-since?since=${lastSeen}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (!res.ok) return;
      const data = await res.json();
      if (data.count > 0) {
        setUnread(data.count);
        if (data.latest) setLatestNM(data.latest);
      } else {
        setUnread(0);
      }
    } catch {
      // Silent fail — no romper la UI por fallo de red
    }
  }, [token, API_URL]);

  // Marcar como leído: almacena timestamp actual
  const markAsRead = useCallback(() => {
    const now = Date.now();
    localStorage.setItem(STORAGE_KEY, String(now));
    setUnread(0);
    setLatestNM(null);
    qc.invalidateQueries({ queryKey: ['nm-notifications'] });
  }, [qc]);

  useEffect(() => {
    if (!token) return;
    fetchCount();
    timerRef.current = setInterval(fetchCount, POLL_INTERVAL_MS);
    return () => clearInterval(timerRef.current);
  }, [fetchCount, token]);

  return { unread, latestNM, markAsRead };
}
